import Vue from 'vue'
import Router from 'vue-router'
import Step1 from '../components/Step1.vue'
import Step2 from '../components/Step2.vue'
import Step3 from '../components/Step3.vue'
import Step4 from '../components/Step4.vue'
import Step5 from '../components/Step5.vue'
import CreditConfirmation from '../components/CreditConfirmation.vue'


Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    savedPosition.x = 0
    savedPosition.y = 0
    return savedPosition
  } else {
    const position = {}

    if (to.hash) {
      position.selector = to.hash

      if (document.querySelector(to.hash)) {
        return position
      }

      return false
    }

    return { x: 0, y: 0 }
  }
}

export default new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/',
      redirect: '/paso-1',
    },
    {
      path: '/paso-1',
      name: 'step1',
      component: Step1
    },
    {
      path: '/paso-2',
      name: 'step2',
      component: Step2
    },
    {
      path: '/paso-3',
      name: 'step3',
      component: Step3
    },
    {
      path: '/paso-4',
      name: 'step4',
      component: Step4
    },
    {
      path: '/paso-5',
      name: 'step5',
      component: Step5
    },
    {
      path: '/confirmacion-solicitud-credito',
      name: 'credit',
      component: CreditConfirmation,
      props: true
    },
    // {
    //   path: '/verproyecto/:projectId',
    //   name: 'singleProject',
    //   component: SingleProject, 
    //   props: { items: true}
    // },
  ]
})